import { IconCalendarMonth, IconMapPin, IconUsers } from '@tabler/icons-react';
import { LinkProps } from '@tanstack/react-router';

import { NavbarLinkConfig } from '../navbar-section/navbar-section';

import { CanAccess, Permission } from '@auth/data-access';

/**
 * Work-in-progress nav entries — add icons/routes here while iterating.
 */
export function getWipNavLinks(
  t: (key: string) => string,
  can: CanAccess,
): NavbarLinkConfig[] {
  return [
    {
      to: '/sampling-plans-map',
      label: t('app.nav.samplingPlansMap'),
      icon: IconMapPin,
      hasAccess: can(Permission.WipPages) && can(Permission.SamplingPlansMap),
    },
    {
      to: '/orders',
      label: t('app.nav.orders'),
      icon: IconCalendarMonth,
      hasAccess: can(Permission.WipPages) && can(Permission.Orders),
    },
    {
      to: '/gp-sampling-assignment',
      label: t('app.nav.gpSamplingAssignment'),
      icon: IconUsers,
      hasAccess: can(Permission.WipPages) && can(Permission.GpSamplingAssignment),
    },
  ];
}

export type WipNavLink = NavbarLinkConfig & { to: LinkProps['to'] };
